
import fetchToCurl from 'fetch-to-curl';
import {TBX_ENVS} from '../config';
import ConfigurationManger from '../config/ConfigurationManager';

if (TBX_ENVS.DEBUG) {
    fetchToCurl();
}

const ERRORS = {
    404: 'Not Found',
    500: 'Server Error'
};

const BUILD_TIMESTAMP = (TBX_ENVS && TBX_ENVS.REACT_APP_BUILDTIME) || Date.now();

const getURLwithBuildTimeParam = (url) => {
    const appendString = /[?&]/.test(url) ? `&v=${BUILD_TIMESTAMP}` : `?v=${BUILD_TIMESTAMP}`;
    return url + appendString;
}

/**
 * Data downloading using pure JS fetch
 *
 * @param  {*}       url     URL to fetch data
 * @param  {*}       options Request options
 * @return {Promise}         Fetch promise
 */
export const fetchData = (url, options) => {
  const completeURL = getURLwithBuildTimeParam(url);
  let finalOptions = {
      ...options
  };

    finalOptions.headers = {
        ...finalOptions.headers,
        'User-Agent': ConfigurationManger.tbxDeviceUserAgent
    }

  const fetchRequest = new Request(completeURL, finalOptions);
  if (TBX_ENVS.DEBUG) console.debug(fetchToCurl(completeURL, finalOptions));

  return fetch(fetchRequest)
    .then(async (response) => {
        let result = {};

        if (!response.ok) {
            const errorDefaultMessage = ERRORS[response.status];
            result.statusCode = response.status;

            result = await response.json();
            console.debug('[netUtils] RESPONSE NOOK >>>', JSON.stringify(result));
            if (!result || Object.keys(result).length === 0) {
                result = result || {};
                result.error = 'Unknown server error!';
            }

            throw result;
        }

        if (response.redirected) {
            window.location.href = response.url;
        }

        const cType = response.headers.get('content-type');
        switch (true) {
            case cType?.includes('application/json'):
                return response.json()
                .then((result) => ({ result }));
            case cType?.includes('application/octet-stream'):
                return response.blob()
                .then((result) => ({ result }));
            default:
                return response.text()
                .then((result) => ({ result }));
        }
    });
};

export const parseURLParams = (url) => {
    let regex = /[?&]([^=#]+)=([^&#]*)/g,
    params = {},
    match;

    while ((match = regex.exec(url))) {
        params[match[1]] = match[2]
        console.log(match[1], match[2])
    }

    return params;
};